import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-16 h-16">
          {/* Cercle de base */}
          <div className="absolute inset-0 border-4 border-blue-50 rounded-full" />
          
          {/* Cercle rotatif principal */}
          <div className="absolute inset-0 border-4 border-blue-500 rounded-full animate-spin border-t-transparent border-l-transparent" 
               style={{ animationDuration: '1.2s' }} />
          
          {/* Cercle rotatif secondaire */}
          <div className="absolute inset-1 border-4 border-blue-400 rounded-full animate-spin border-t-transparent border-l-transparent"
               style={{ animationDuration: '1.8s', opacity: 0.7 }} />
          
          {/* Point central avec pulsation subtile */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" 
                 style={{ animationDuration: '1.5s' }} />
          </div>
        </div>
        <div className="text-blue-600 font-medium animate-pulse"
             style={{ animationDuration: '2s' }}>
          Chargement...
        </div>
      </div>
    </div>
  );
}